<template>
    <div>
        <div class="angebote__self-legende" v-if="Angebote.length > 0 && Angebote">
                <div class="row">
                    <div class="col-2">
                        <div class="inner">{{$t('Vermieter.Status')}}</div>
                    </div>
                    <div class="col-2">
                        <div class="inner">m2</div>
                    </div>
                    <div class="col-3">
                        <div class="inner">{{$t('Angebot.Zimmerart')}}</div>
                    </div>
                    <div class="col-3">
                        <div class="inner">{{$t('Angebot.Ort')}}</div>
                    </div>
                </div>
            </div>
        <div v-else>
            <h2 class="mb-5">{{$t('Vermieter.KeineAngebote')}}</h2>
            <router-link :to="{ name: 'angeboteNeu', params: {isAdminEdit: isAdminEdit, adminEditFor: adminEditFor}}"  class="nav-links ">
                <button type="button" class="btn btn-outline-danger waves-effect">{{$t('Vermieter.Button01')}}</button>
            </router-link>
        </div>

        <div class="angebote__self--wrapper">
            <template class="" v-for="Angebot in Angebote">
                <single-item :Angebot="Angebot" v-bind:key="Angebot.persistence_object_identifier"  :isAufMerkliste="true" :listOrte="listOrte"/>
            </template>
            <Lightbox></Lightbox>
        </div>
        <div class="footer__legende">
            <h3 class="font-weight-bold">{{$t('Vermieter.Legende')}}</h3>
            <div class="icon__wrapper">
                <div class="icon__item">
                    <p>{{$t('Vermieter.Freigegeben')}}</p>
                    <img src="@/assets/icons/icon_freigegeben.svg">
                </div>
                <div class="icon__item">
                    <p>{{$t('Vermieter.Abgelehnt')}}</p>
                    <img src="@/assets/icons/icon_abgelehnt.svg">
                </div>
                <div class="icon__item">
                    <p>{{$t('Vermieter.Bearbeitung')}}</p>
                    <img src="@/assets/icons/icon_bearbeitung.svg">
                </div>
                <div class="icon__item">
                    <p>{{$t('Vermieter.Ausstehend')}}</p>
                    <img src="@/assets/icons/icon_ausstehend.svg">
                </div>
              <div class="icon__item">
                <p>{{$t('Vermieter.Deaktiviert')}}</p>
                <img src="@/assets/icons/icon_deaktiviert.svg">
              </div>
            </div>
        </div>
    </div>

   
</template>

<script>

import { mdbIcon, mdbSpinner } from 'mdbvue';
import { mdbDatatable } from 'mdbvue';
import settings from '@/components/Settings.json';
import AngebotService from "@/services/AngebotService";
import EmailService from "@/services/EmailService";
import singleItem from '@/components/angebot/vermieter/AngebotItemVermieter';
import SettingService from '@/services/SettingsService';
import Lightbox from "@/components/Lightbox";

export default {
  name: "AngeboteVermieter",
    components: {
      mdbIcon,
        mdbDatatable,
        singleItem,
        mdbSpinner,
        Lightbox

  },
  data() {
    return {
        arten: [],
        listOrte: [],
        Texte: "",

    };
  },
  props: {
    isAdminEdit: {
      default: false,
    },
    adminEditFor: {
      default: false,
    },
    Angebote: Array,
    isLoading: 1,
      isAufMerkliste: true,
  }, 
  methods: {

      openModal(id) {
            this.$parent.showModal(id)
      },
      closeModal(){
          this.modalActive = false;
      },
      emitChange(){
        console.log("Refresh")
            this.$parent.refreshAngebote();
      },
      selectOrt(key) {
        if(!key){return}
          key = key.replace(/ /g,'');
          this.listOrte.forEach(option => {
              if(option.value == key){
                  option.selected = true;
                  this.Angebot.ort = option.text;
              }
          });
      },
      addToOrte(array, index){
          let liste = this.listOrte;
          if(index == 1){
              liste.push({ text: 'Freiburger Stadtteile', value: null, disabled: true, optgroup: true });
              for(let i = 0; i < array.length; i++){
                  let item = {text: array[i].SettingValue.toString(), value:array[i].SettingId, index: i};
                  liste.push(item)
              }
          } else if(index == 2){
              liste.push({ text: 'Orte in Umgebung', value: null, disabled: true, optgroup: true });
              for(let i = 0; i < array.length; i++){
                  let item = {text: array[i].SettingValue.toString(), value:array[i].SettingId, index: i};
                  liste.push(item)
              }
          }
          this.listOrte = liste;
      },
      getListFreiburg(){
          SettingService.getSettings(1)
              .then(response => {
                  this.addToOrte(response.data, 1);
              })
              .catch(error => {
                  console.log("There was an error:", error.response);
              });
      },
      getListUmgebung(){
          SettingService.getSettings(2)
              .then(response => {
                  this.addToOrte(response.data, 2);
              })
              .catch(error => {
                  console.log("There was an error:", error.response);
              });
      }
  },
    mounted() {
        this.getListFreiburg();
        this.getListUmgebung();
        this.arten = settings.Settings[1][this.$store.getters.lang][0].Zimmerarten;
        //this.selectOrt(this.Angebot.ort);
    },
    created() {
        this.Texte = this.$locales.Texte;
    },
}

</script>
